import {
  ASSUMPTION_NAME,
  ASSUMPTIONS,
  COMMUNITY_DURATION,
  COMMUNITY_INVESTMENT,
  COUNTRY_OF_OPERATION,
  EVENT_DURATION,
  EVENT_INVESTMENT,
  REPORTING_PERIOD_END,
  REPORTING_PERIOD_START,
  STAKEHOLDERS_LIST
} from './fields'
import { END_DATE, START_DATE } from '../../../../../forms/ReusableFormFields/StartEndDateRangeFields/fields'

const preserveNullAndZeroValues = object => {
  // This function is used to keep null or 0 values in the payload
  // (they are rewritten to empty string in formik values, and it leads to incorrect payload when sending to BE)
  return Object.entries(object).reduce((acc, [key, currentValue]) => {
    if (['id', 'data'].includes(key)) {
      return acc
    }

    const originalValue = object.data[key]
    const isCurrentValueNumber = !isNaN(Number(currentValue))
    const isOriginalValueNumber = !isNaN(Number(originalValue))

    if (currentValue || currentValue === 0) {
      acc[key] = isCurrentValueNumber ? Number(currentValue) : currentValue
    } else if (!currentValue && originalValue) {
      acc[key] = isOriginalValueNumber ? 0 : ''
    } else if (!currentValue && !originalValue) {
      acc[key] = originalValue
    }

    return acc
  }, {})
}

export const transformValuesToBE = (sroiReport, values) => {
  const filledAssumptions = values[ASSUMPTIONS].filter(assumption => assumption[ASSUMPTION_NAME])

  return {
    payload: {
      ...sroiReport.payload,
      // general inputs section
      [COUNTRY_OF_OPERATION]: values[COUNTRY_OF_OPERATION],
      [REPORTING_PERIOD_START]: values[START_DATE],
      [REPORTING_PERIOD_END]: values[END_DATE],
      [EVENT_INVESTMENT]: values[EVENT_INVESTMENT],
      [EVENT_DURATION]: values[EVENT_DURATION],
      [COMMUNITY_INVESTMENT]: values[COMMUNITY_INVESTMENT],
      [COMMUNITY_DURATION]: values[COMMUNITY_DURATION],
      // assumptions section
      [ASSUMPTIONS]: filledAssumptions.map(assumption => preserveNullAndZeroValues(assumption)),
      // stakeholders section
      [STAKEHOLDERS_LIST]: values[STAKEHOLDERS_LIST].map(stakeholder => preserveNullAndZeroValues(stakeholder))
    }
  }
}
